module.exports = __webpack_public_path__ + "223fee8ad2e573c8be28ab7d3c9acedf.jpg";